// Campus photo for /colleges/university-of-nevada-reno: CC BY-SA 3.0, by Tonywiki09, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_Nevada_Quad%2C_2009-11-08.JPG), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-nevada-reno/; credited under the photo.
const photo = {
    "slug": "university-of-nevada-reno",
    "alt": "The tree-lined Quad in autumn, looking toward a columned hall at the University of Nevada, Reno",
    "src": "/colleges/university-of-nevada-reno/campus-1600.webp",
    "srcSmall": "/colleges/university-of-nevada-reno/campus-800.webp",
    "srcMid": "/colleges/university-of-nevada-reno/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-nevada-reno/og.jpg",
    "title": "University of Nevada Quad, 2009-11-08",
    "author": "Tonywiki09",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_Nevada_Quad%2C_2009-11-08.JPG",
    "read": "2026-10-02"
};

export default photo;
